module.exports = __webpack_public_path__ + "static/img/brand-third-4.7ce43718.png";